import { connect } from 'react-redux'
import { password } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSaveAndRedirect } from './actions'
import PasswordPageView from './view'

const validators = {
  password,
}

const initialValues = {
  password: '',
}

const select = () => ({
  initialValues,
  validators,
})

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(PasswordPageView))
